import { bool, func, number } from 'prop-types'
import { connectPagination } from 'react-instantsearch-dom'

import Pagination from 'views/components/molecules/Pagination'

const handleClick = refine => index => refine(index)

const PaginationConnected = ({
  currentRefinement,
  nbPages,
  refine,
  showLabel,
  small,
  scrollToTopAfterClick,
}) => {
  if (nbPages <= 1) {
    return null
  }

  return (
    <div
      className="l-flex l-flex--justify-content--end@medium l-flex--center@small-tiny"
      data-qa-id="pagination-links"
    >
      <Pagination
        currentPageNum={currentRefinement}
        maxPageNum={nbPages}
        onPageItemClick={handleClick(refine)}
        onPrevPageItemClick={handleClick(refine)}
        onNextPageItemClick={handleClick(refine)}
        showLabel={showLabel}
        small={small}
        scrollToTopAfterClick={scrollToTopAfterClick}
      />
    </div>
  )
}

PaginationConnected.propTypes = {
  currentRefinement: number.isRequired,
  nbPages: number.isRequired,
  refine: func.isRequired,
  showLabel: bool,
  small: bool,
  scrollToTopAfterClick: bool,
}

PaginationConnected.defaultProps = {
  showLabel: false,
  small: false,
  scrollToTopAfterClick: false,
}

export default connectPagination(PaginationConnected)
